import { AppState } from 'src/store/appstate';

// Units../appstate

export const selectAllCompanies = (state: AppState) => state.entityStores.company.entities;

export const selectAllUnits = (state: AppState) => state.entityStores.unit.entities;

// Unit Positions
export const selectAllUnitPostions = (state: AppState) => state.entityStores.unitPosition.entities;

export const selectAllBases = (state: AppState) => state.entityStores.base.entities;

export const selectAllVehicles = (state: AppState) => state.entityStores.vehicle.entities;

export const selectAllPeople = (state: AppState) => state.entityStores.person.entities;

export const selectAllRegions = (state: AppState) => state.entityStores.region.entities;

export const selectAllRegionGroups = (state: AppState) => state.entityStores.regionGroup.entities;

export const selectAllDepartments = (state: AppState) => state.entityStores.department.entities;

export const selectAllOperations = (state: AppState) => state.entityStores.operation.entities;

export const selectAllCards = (state: AppState) => state.entityStores.card.entities;

export const selectAllRequests = (state: AppState) => state.entityStores.request.entities;

export const selectAllRequesters = (state: AppState) => state.entityStores.requester.entities;

export const selectAllRequestPatients = (state: AppState) =>
  state.entityStores.requestPatient.entities;

export const selectAllRequestLocations = (state: AppState) =>
  state.entityStores.requestLocation.entities;

export const selectAllTrips = (state: AppState) => state.entityStores.trip.entities;

export const selectAllTripLegs = (state: AppState) => state.entityStores.tripLeg.entities;

export const selectAllWaypoints = (state: AppState) => state.entityStores.waypoint.entities;

export const selectAllVehicleDispositions = (state: AppState) =>
  state.entityStores.vehicleDisposition.entities;

export const selectAllManifestEntries = (state: AppState) =>
  state.entityStores.manifestEntry.entities;

export const selectAllTripPassengers = (state: AppState) =>
  state.entityStores.tripPassenger.entities;

export const selectAllCardNotes = (state: AppState) => state.entityStores.cardNote.entities;

export const selectAllUnitNotes = (state: AppState) => state.entityStores.unitNote.entities;

export const selectAllPositionReports = (state: AppState) => {
  return state.entityStores.positionReport.entities;
};

export const selectAllFlightFollowingReports = (state: AppState) =>
  state.entityStores.flightFollowingReport.entities;

export const selectAllTransportOffers = (state: AppState) =>
  state.entityStores.transportOffer.entities;

export const selectAllTransportReasons = (state: AppState) =>
  state.entityStores.transportReason.entities;

export const selectAllEtas = (state: AppState) => state.entityStores.eta.entities;

export const selectAllEstimatedDurations = (state: AppState) =>
  state.entityStores.estimatedDuration.entities;

export const selectAllTimestampTypes = (state: AppState) =>
  state.entityStores.timestampType.entities;

export const selectAllTimestamps = (state: AppState) => state.entityStores.timestamp.entities;

export const selectAllRendezvousRequests = (state: AppState) =>
  state.entityStores.rendezvousRequest.entities;

export const selectAllTimezones = (state: AppState) => state.entityStores.timezone.entities;

export const selectAllNotifications = (state: AppState) => state.entityStores.notification.entities;

export const selectAllNotificationRecipients = (state: AppState) =>
  state.entityStores.notificationRecipient.entities;

export const selectAllApplicationNotifications = (state: AppState) =>
  state.entityStores.applicationNotification.entities;

export const selectAllAccessibleItems = (state: AppState) =>
  state.entityStores.accessibleItem.entities;

export const selectAllExternalReferences = (state: AppState) =>
  state.entityStores.externalReference.entities;

export const selectAllRequesterReferralReasons = (state: AppState) =>
  state.entityStores.requesterReferralReason.entities;

export const selectAllCardSummaries = (state: AppState) => state.entityStores.cardSummary.entities;

export const selectAllMessageStatusUpdates = (state: AppState) =>
  state.entityStores.messageStatusUpdate.entities;

export const selectAllQuestions = (state: AppState) => state.entityStores.question.entities;

export const selectAllQuestionChoices = (state: AppState) =>
  state.entityStores.questionChoice.entities;

export const selectAllQuestionnaireResponses = (state: AppState) =>
  state.entityStores.questionnaireResponse.entities;

export const selectAllQuestionnaireSectionQuestions = (state: AppState) =>
  state.entityStores.questionnaireSectionQuestion.entities;

export const selectAllTransferReasons = (state: AppState) =>
  state.entityStores.transferReason.entities;

export const selectAllTransferCenters = (state: AppState) =>
  state.entityStores.transferCenter.entities;

export const selectAllVehicleStateInspections = (state: AppState) =>
  state.entityStores.vehicleStateInspection.entities;

export const selectAllMedicalControlContactLogEntries = (state: AppState) =>
  state.entityStores.medicalControlContactLogEntry.entities;
